import { render, staticRenderFns } from "./base-remote-select.vue?vue&type=template&id=385cbd65"
import script from "./base-remote-select.vue?vue&type=script&lang=js"
export * from "./base-remote-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('385cbd65')) {
      api.createRecord('385cbd65', component.options)
    } else {
      api.reload('385cbd65', component.options)
    }
    module.hot.accept("./base-remote-select.vue?vue&type=template&id=385cbd65", function () {
      api.rerender('385cbd65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/inputs/base-remote-select.vue"
export default component.exports